import type { IconName } from '@/shared/ui/base-icon';
import type { ReactionType } from '../types';

export const reactionTypeToIconName = (
  reactionType: ReactionType,
): IconName => {
  return `emoji-${reactionType}` as IconName;
};
